import { forwardRef } from "react";
import { type TypographyProps } from "~/common/mui";
import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { StockIndicatorV2 } from "~/domains/product/components/StockIndicator/StockIndicator";
import classNames from "classnames";
import classes from "./StockIndicator/StockIndicator.module.less";

type Props = BaseProductElementProps & Omit<TypographyProps, "children">;

export const StockIndicator = forwardRef<HTMLElement, Props>((props) => {
  const product = useProductContext(props);

  if (!userHasPermission(Permission.AVAILABILITY)) {
    return null;
  }

  return <StockIndicatorV2 stock={product.stockAmount} className={classNames(props.className, classes.stockTag)} />;
});
